import { render } from "./VwTestCategoryColumn.vue?vue&type=template&id=5baa70a8"
import script from "./VwTestCategoryColumn.vue?vue&type=script&lang=js"
export * from "./VwTestCategoryColumn.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__